import React from 'react';
import { Box, createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    '@global': {
      '*': {
        margin: 0,
        padding: 0,
      },
      html: {
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        width: '100%',
        margin: 0,
      },
      '#app': {
        height: '100%',
        width: '100%',
      },
    },
    main: {
      height: '100%',
    },
  }),
);

export const OnboardingPageLayout: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <Box className={classes.main} display="flex" flexDirection="column">
      <Box margin="auto" width={1}>
        {children}
      </Box>
    </Box>
  );
};
